import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import OcrHrDemonstration from './OcrHrDemonstration';
import less from './FunctionalExperienceTab.less';

class HandwritingRecognition extends React.Component {
  constructor() {
    super();
    this.state = {
      currentIndex: 0
    };
  }

  handleTabClick(index) {
    this.setState({
      currentIndex: index
    });
  }

  render() {
    return (
      <>
        <Row>
          <Col span={16}>
            <div className={less.tab}>
              <div className={less.title}>
                {this.props.selectList.length > 0
                  ? this.props.selectList.map((item, index) => {
                      return (
                        <p
                          key={item.key}
                          onClick={() => this.handleTabClick(index)}
                          className={
                            less.titleContent +
                            ' ' +
                            (this.state.currentIndex === index
                              ? less.active
                              : '')
                          }
                        >
                          {item.label}
                        </p>
                      );
                    })
                  : null}
              </div>
            </div>
          </Col>
        </Row>
        {this.state.currentIndex === 0 && (
          <OcrHrDemonstration
            materialsPath={this.props.materialsPath}
            selectList={this.props.selectList}
          />
        )}
        {this.state.currentIndex === 1 && (
          <OcrHrDemonstration
            materialsPath={this.props.materialsPathEn}
            selectList={this.props.selectList}
          />
        )}
      </>
    );
  }
}

HandwritingRecognition.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array,
    selectList: PropTypes.array,
    materialsPathEn: PropTypes.array
  })
};

export default HandwritingRecognition;
